// src/lib/consent.js
const IN_BROWSER = typeof window !== "undefined";

const STORAGE_KEY = "pc_cookie_consent_v1";
export const CONSENT_ACCEPTED = "accepted";
export const CONSENT_REJECTED = "rejected";

export function getCookieConsent() {
  if (!IN_BROWSER) return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent() {
  return getCookieConsent() === CONSENT_ACCEPTED;
}

export function setCookieConsent(value) {
  if (!IN_BROWSER) return;
  try {
    if (value == null) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore
  }
  window.dispatchEvent(new Event("pc:cookie-consent-changed"));
}

export function openCookieSettings() {
  if (!IN_BROWSER) return;
  window.dispatchEvent(new Event("pc:open-cookie-settings"));
}

